import { LoadingSpinner } from "../../../bits/loading";
import BookshelfIcon from "@assets/compass.svg";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { AuthenticatorContainer } from "./authenticatorContainer";
import { Trademark } from "./trademark";

const AuthenticatorLoadingContainer = styled(AuthenticatorContainer)`
  height: 310px;
`;

export const AuthenticatorLoading = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img
        css={css`
          box-shadow: none;
          background-color: transparent;
          width: 212px;
          margin-bottom: 32px;
          padding-bottom: 32px;
          padding-left: 32px;
          @media (max-width: 1000px) {
            padding: 32px 32px 0px 32px;
          }
        `}
        src={BookshelfIcon}
        alt="Compass"
        title="Home"
      />
      <AuthenticatorLoadingContainer>
        <LoadingSpinner
          css={css`
            width: 100%;
          `}
        />
      </AuthenticatorLoadingContainer>
      <Trademark />
    </div>
  );
};
